<div class="modal-overlay" *ngIf="isOpen" (click)="handleCancel()">
  <div class="modal-dialog" (click)="$event.stopPropagation()">
    <div class="modal-header">
      <h2>{{ testRunMode ? 'Select Samples for Test Run' : 'Run Test' }}</h2>
      <button class="close-btn" (click)="handleCancel()" aria-label="Close">
        <span aria-hidden="true">&times;</span>
      </button>
    </div>
    
    <div class="modal-body">
      <div class="document-info">
        <strong>Document Model:</strong> {{ documentModel }}
      </div>
      
      <!-- Radio buttons (only show when NOT in test run mode) -->
      <div class="run-type-selection" *ngIf="!testRunMode">
        <h3>Run validation for:</h3>
        
        <div class="radio-option">
          <input 
            type="radio" 
            id="runTypeFull" 
            name="runType" 
            value="full" 
            [(ngModel)]="runType"
            (change)="onRunTypeChange()"
          >
          <label for="runTypeFull">
            <strong>Whole Document Model</strong>
            <span class="option-description">Run validation for all samples in this document model</span>
          </label>
        </div>
        
        <div class="radio-option">
          <input 
            type="radio" 
            id="runTypePartial" 
            name="runType" 
            value="partial" 
            [(ngModel)]="runType"
            (change)="onRunTypeChange()"
          >
          <label for="runTypePartial">
            <strong>Selected Samples</strong>
            <span class="option-description">Run validation for specific samples only (test run)</span>
          </label>
        </div>
      </div>
      
      <div class="file-selection-container" *ngIf="runType === 'partial' || testRunMode">
  <div class="file-selection-header">
    <h4>Select Samples</h4>
    <span class="selection-count" *ngIf="!isLoadingFiles">{{ selectedCount }} / {{ files.length }} selected</span>
  </div>
  
  <!-- LOADER: Show while fetching files -->
  <div class="docsila-loader" *ngIf="isLoadingFiles">
    <div class="beat-loader">
      <div class="beat"></div>
      <div class="beat"></div>
      <div class="beat"></div>
      <div class="beat"></div>
      <div class="beat"></div>
    </div>
    <p class="loader-text">Loading files...</p>
  </div>
  
  <!-- FILE LIST: Show after loading completes -->
  <div class="file-list" *ngIf="!isLoadingFiles && files.length > 0">
    <div class="file-item" *ngFor="let file of files">
      <input 
        type="checkbox" 
        [id]="'file-' + file.uuid" 
        [checked]="isFileSelected(file.uuid)"
        (change)="toggleFileSelection(file.uuid)"
      >
      <label [for]="'file-' + file.uuid">
        <span class="file-name">{{ file.file_name }}</span>
      </label>
    </div>
  </div>
  
  <!-- NO FILES MESSAGE: Only show after loading completes -->
  <div class="no-files-message" *ngIf="!isLoadingFiles && files.length === 0">
    <p>⚠️ No files available for this document model.</p>
    <p class="hint">Please upload files in the Facts page first.</p>
  </div>
        
        <div class="validation-error" *ngIf="validationError">
          <span class="error-icon">⚠️</span>
          <span>{{ validationError }}</span>
        </div>
      </div>
    </div>
    
    <div class="modal-footer">
      <button 
        class="btn btn-secondary" 
        (click)="handleCancel()"
      >
        Cancel
      </button>
      <button 
        class="btn btn-primary" 
        (click)="handleConfirm()"
        [disabled]="(runType === 'partial' || testRunMode) && selectedFileIds.size === 0"
      >
        {{ testRunMode ? 'Run Test' : 'Run Test' }}
      </button>
    </div>
  </div>
</div>
